
<div *ngIf="dialerClientService.dialerService.bInitialized&&pathTestPointSeq">
    <div *ngIf="errorMsg" class="alert alert-danger d-inline-block">
        <div class="d-flex flex-row justify-content-between">
            <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
            {{errorMsg | shorten:200:'...'}}
            <div role="button" (click)="errorMsg=''"><i class="fa fa-times ml-2"></i></div>
        </div>
    </div>
    <dialer-monitor #dialerMonitor
        [testPointId]="pathTestPoint?.id"
        [seqId]="pathTestPointSeq?.dialerSeqId || 'X'"
        [filterFn]="monitorRowFilter"
        [refresh$]="monitorRefresh$"
        class="w-100">
    </dialer-monitor>
    <div class="d-flex flex-row justify-content-between pt-1">
        <div class="d-flex flex-row">
            <div class="pr-2">
                <ng-content></ng-content>
            </div>
            <div *ngIf="dialerMonitor.tableRows.length && !dialerMonitor.allRowsEnabled">
                <label class="form-check-inline">
                    <input type="checkbox" [(ngModel)]="hideDisabledMonitorRows" (change)="updateMonitorFilter()">
                    &nbsp;Hide disabled
                </label>
            </div>
        </div>
    </div>
</div>


